import { FilterDefinitionType, FilterType } from "@/components/@types";
import { Popper } from "@/components/atoms/Popper";
import { FilterChipValueContent } from "@/components/organisms/UtilityBar/FilterChip/FilterChipValueContent";
import { FilterChipValuePicker } from "@/components/organisms/UtilityBar/FilterChip/FilterChipValuePicker";
import {
  CHIP_WORDS_CLASS,
  toTestId,
} from "@/components/organisms/UtilityBar/FilterChip/FilterChip.tools";
import { Button } from "@/components/ui/button";
import { ButtonGroupText } from "@/components/ui/button-group";
import { cn } from "@/components/ui/utils";

export function FilterChipValueSection({
  filter,
  filterDefinition,
  isLocked,
  isValueOpen,
  setIsValueOpen,
  filterIndex,
}: {
  filter: FilterType;
  filterDefinition: FilterDefinitionType;
  isLocked: boolean;
  isValueOpen: boolean;
  setIsValueOpen: (isOpen: boolean) => void;
  filterIndex: number;
}) {
  const testId = `filter-chip-value-${toTestId(filterDefinition?.name)}`;
  const value = (
    <FilterChipValueContent
      filter={filter}
      filterDefinition={filterDefinition}
    />
  );
  if (isLocked) {
    return (
      <ButtonGroupText
        data-testid={testId}
        className={cn(CHIP_WORDS_CLASS, "text-muted-foreground")}
      >
        {value}
      </ButtonGroupText>
    );
  }
  return (
    <Popper
      anchorLayout="button-group"
      isOpenState={[isValueOpen, setIsValueOpen]}
      anchor={
        <Button
          variant="outline"
          size="sm"
          data-testid={testId}
          className={cn(!filter.value && "text-muted-foreground")}
        >
          {value}
        </Button>
      }
      floatingStyle={{ padding: 0 }}
    >
      <FilterChipValuePicker
        filter={filter}
        filterDefinition={filterDefinition}
        setIsValueOpen={setIsValueOpen}
        filterIndex={filterIndex}
      />
    </Popper>
  );
}
